<template>
    <div class="register-existing">
        <b-row class="justify-content-center">
            <b-col sm="12" md="12" class="text-center mb-50">
                <h2>Registrierung bestätigen</h2>
                <h5>Bitte trage hier die Mitgliedsnummer deines Kindes ein, um mit der Registrierung fortzufahren.</h5>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col sm="8" lg="5" class="section mb-3 p-3 clearfix">
                <div class="mandatory-note text-center">
                    <p>* Pflichtfelder bitte ausfüllen</p>
                </div>
                <form>
                    <div class="form-row">
                        <div class="form-group col-12 floating-label mb-40 mt-30 hide">
                            <input type="text" class="form-control" placeholder="Opt-in-Code" v-model.trim="optInCode">
                        </div>
                        <div class="form-group col-12 floating-label mb-40 mt-30 hide">
                            <input type="text" class="form-control" placeholder="Aktivierungscode"
                                   v-model.trim="activationCode">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12 floating-label mb-40 mt-30">
                            <input type="text" class="form-control" placeholder="Mitgliedsnummer"
                                   v-model.trim="membershipNumber"/>
                            <label>Mitgliedsnummer des Kindes*</label>
                        </div>
                    </div>
                    <div class="mb-40 text-center">
                        <button class="btn btn-primary"
                                type="button"
                                :disabled="!$vuelidation.valid()"
                                @click="checkIfExists()">Weiter zum nächsten Schritt
                        </button>
                    </div>
                </form>

            </b-col>
        </b-row>
    </div>
</template>
<script>

    import {apiDigitalRegistration} from "../utils/api";

    export default {
        name: 'registerExistingView',
        data() {
            return {
                registerExistingComponentResponse: {},
                items: {},
                optInCode: '',
                activationCode: '',
                membershipNumber: null
            };
        },
        vuelidation: {
            data: {
                optInCode: {
                    required: true
                },
                activationCode: {
                    required: true
                },
                membershipNumber: {
                    required: true
                }
            }
        },
        methods: {
            checkIfExists() {

                apiDigitalRegistration({
                    "optInCode": this.optInCode,
                    "membershipNumber": this.membershipNumber,
                    "activationCode": this.activationCode
                })

                    .then(response => {
                        // JSON responses are automatically parsed.

                        if (response.data.code === 0) {
                            this.$store.commit('storeProfileData', response.data);
                            this.items = response.data;
                            this.$router.push({name: 'registrierung-daten', params: {prefillData: this.items}});
                        } else if (response.data.code === 1)
                            this.$toasted.error('Ungültiger Seitenaufruf. Bitte nutzen Sie den Link aus Ihrer Bestätigungs-E-Mail.', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else if (response.data.code === 99)
                            this.$toasted.error('Bitte gib eine gültige Mitgliedsnummer ein.', {
                                duration: 3000,
                                position: 'bottom-right'
                            });
                        else
                            this.$toasted.error('Etwas ist schief gelaufen, bitte versuche es erneut!', {
                                duration: 3000,
                                position: 'bottom-right'
                            });

                    })
                    .catch(e => {
                        this.$store.commit('error', e);
                    });
            }
        },
        mounted: function () {

            if (this.$route.query.oic || this.$route.query.act) {
                this.optInCode = this.$route.query.oic;
                this.activationCode = this.$route.query.act;
            }
        }
    };
</script>
